module.exports = __webpack_public_path__ + "static/media/Item_Row_Gold@3x.2d0ea1d0.png";